import(/* webpackMode: "eager" */ "/tmp/8df18e38933c20a/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df18e38933c20a/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df18e38933c20a/src/app/metrics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df18e38933c20a/src/components/ClientInit/ClientInit.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df18e38933c20a/src/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df18e38933c20a/src/styles/global.scss");
